import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectWorkflowId } from "@utils/parameter-injector";
import { WorkflowChangeRequestResponse } from "@idw-types/data/workflow-change-request";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type DeleteWorkflowRequestResponse = {
    transferObject: WorkflowChangeRequestResponse;
};

export const deleteWorkflowRequest = async (
    workflowId: string
): Promise<GenericNetworkResponse<DeleteWorkflowRequestResponse>> => {
    const route = injectWorkflowId(apiRoutes.serviceConfiguration.workflow.delete, workflowId);

    const { data, error } = await handleRequest(RequestTypes.POST, route);
    return { data, error };
};